import { render, staticRenderFns } from "./CreateUpdate.vue?vue&type=template&id=d65b6f26&scoped=true&"
import script from "./CreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CreateUpdate.vue?vue&type=style&index=0&id=d65b6f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65b6f26",
  null
  
)

export default component.exports